import { unref } from 'vue';
import fastdom from 'fastdom';
import fastdomPromised from 'fastdom/extensions/fastdom-promised';


const fastdomP = fastdom.extend(fastdomPromised);

/**
 * Асинхронно получаем координаты элемента, используя `IntersectionObserver`
 * или `boundingClientRect` если первый недоступен
 * @param {HTMLElement | Ref<HTMLElement>} el
 * @param {boolean} reflow - делает расчет в основном потоке (без задержек, но влияет на производительность)
 * @returns {Promise<DOMRect|DOMRectReadOnly>}
 */
export const getRect = async (el, reflow) => {
    let bounds;

    if (!(unref(el) instanceof Element)) {
        bounds = {};
    } else if ('IntersectionObserver' in window && !reflow) {
        bounds = await new Promise((res) => {
            const observer = new IntersectionObserver(entries => {
                for (const entry of entries) {
                    res(entry.boundingClientRect);
                }
                observer.disconnect();
            });

            observer.observe(unref(el));
        });

    } else {
        await fastdomP.measure(() => {
            bounds = unref(el).getBoundingClientRect();
        });
    }

    return bounds;
};
